import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get, post } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { EngineeringStatus, IEngNetStatusState } from 'features/EngineeringNetStatus/types';

const initialState: IEngNetStatusState = {
  data: {} as EngineeringStatus,
  loading: false,
};

const reset: IReducer<IEngNetStatusState, IEngNetStatusState | null> = () => initialState;

const data: CaseReducer<IEngNetStatusState, PayloadAction<EngineeringStatus>> = (state, action) => {
  state.data = action.payload;
};

export const engineeringStatusSlice = createSlice({
  name: 'CARDS/engineering_status',
  initialState,
  reducers: {
    loading: loading as IReducer<IEngNetStatusState, boolean>,
    data,
    reset,
  },
});

const {
  data: setEngineering,
  loading: setLoading,
  reset: setEngineeringReset,
} = engineeringStatusSlice.actions;

export const getEngineeringNetwork =
  (structure: number, network: number): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<EngineeringStatus>(
      `/api/v2/standards/engineering_networks/structure/${structure}/network-status/`,
      {
        network_type: network,
      },
    )
      .then(({ data }) => {
        dispatch(setEngineering(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const setEngineeringNetworkStatusSettlement =
  (networkType: number, structure: number, data: PostDataSettlement): AppThunk =>
  dispatch => {
    post('/api/v2/timesheet/engineering-appointment/settlement/', data).then(() => {
      dispatch(getEngineeringNetwork(structure, networkType));
    });
  };

export const setEngineeringNetworkStatusExploitation =
  (networkType: number, structure: number, data: PostDataExploitation): AppThunk =>
  dispatch => {
    post('/api/v2/timesheet/engineering-appointment/exploitation/', data).then(() => {
      dispatch(getEngineeringNetwork(structure, networkType));
    });
  };

export { setEngineeringReset };

interface PostDataSettlement {
  date: string;
  network: number;
  sections: number[] | null;
  subnets: number[] | null;
  subnetsBySections:
    | {
        subnet: number;
        section: number;
      }[]
    | null;
  comment: string;
}

interface PostDataExploitation {
  network: number;
  date: string;
  comment: string;
}
